import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import {fb, anlyt}   from './firebase'
import i18n from './i18n'

// VueOffline
import VueOffline from 'vue-offline'
Vue.use(VueOffline)

// VueGoogleMaps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDHflp-kA8S_bYDw5okd-Uy7CF1MXJMs5U',
    libraries: 'places'
  }
})

import VueTimeago2 from "vue-timeago2";
Vue.use(VueTimeago2, {
  name: "Timeago",
  locale: "en"
});

// VueAds
import Ads from 'vue-google-adsense'
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

// VueMeta
import Meta from 'vue-meta'
Vue.use(Meta)

// Vue Qrcode Reader
import VueQrcodeReader from "vue-qrcode-reader"
Vue.use(VueQrcodeReader)

// Vue2Filters
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Vue-Firestore
import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

// Bulma on vue
import "bulma/css/bulma.css"

// SweetAlert
import Swal from 'sweetalert2'

window.Swal = Swal
/* eslint-disable */
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
/* eslint-enable */
window.Toast = Toast

// Basic Indexed Global Components
Vue.component('product', require('./components/Product/Index.vue').default)
Vue.component('event', require('./components/Event/Index.vue').default)
Vue.component('service', require('./components/Service/Index.vue').default)

// Basic Indexed Global Components
Vue.component('topnav', require('./components/Navbar/topnav.vue').default)
Vue.component('midnav', require('./components/Navbar/midnav.vue').default)

// Basic Buttons
Vue.component('generalfab', require('./components/Buttons/GenFAB.vue').default)

Vue.prototype.$analytics = anlyt

Vue.config.productionTip = false

let app = ''
/* eslint-disable */
fb.auth().onAuthStateChanged(() => {
  if(!app){
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount("#app")  
  }
})
/* eslint-enable */
